import AcademicMobilityPage from "./AcademicMobilityPage";

export default AcademicMobilityPage;